import React from 'react'

const RightsholderMaintenanceBankingTabHeader = () => (
    <>
        <p>
            The Banking and Tax tab needs to be fully completed before any royalties can be paid out. Click{' '}
            <a href="https://www.youtube.com/watch?v=pkp_zZGseBQ" target="_blank">
                here
            </a>{' '}
            to view a video with instructions on how to add your banking and tax information correctly.
        </p>
        <p>
            <strong>*Please note:</strong> To ensure the royalties for each distribution are routed correctly,
            <strong> this page is temporarily disabled from the 3rd through the 14th of each month.</strong> This occurs
            on Central Standard Time (CST) at midnight.
        </p>
    </>
)

export default RightsholderMaintenanceBankingTabHeader
